import { P } from '../../styles/theme';

export default function Btn({ children, onClick, variant = 'primary', size = 'md', style: s = {}, disabled = false }) {
  const styles = {
    primary:   { background: `linear-gradient(135deg, ${P.rose}, ${P.deep})`, color: '#fff', border: 'none' },
    secondary: { background: P.peach, color: P.deep, border: 'none' },
    ghost:     { background: 'transparent', color: P.muted, border: `1.5px solid ${P.border}` },
    danger:    { background: '#FFF0F0', color: P.red, border: `1.5px solid #E5C0C0` },
  };
  const sizes = {
    sm: { padding: '6px 14px',  fontSize: '12px' },
    md: { padding: '10px 20px', fontSize: '14px' },
    lg: { padding: '12px 24px', fontSize: '14px' },
  };
  return (
    <button disabled={disabled} onClick={onClick} style={{
      borderRadius: '10px', fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'all 0.15s', fontFamily: "'Nunito', sans-serif", opacity: disabled ? 0.6 : 1,
      ...styles[variant], ...sizes[size], ...s,
    }}>
      {children}
    </button>
  );
}
